import LanguageManager from '../../modules/language_manager/language_manager';

export default class ERRORS {
    static get GENERAL_PARSING_ERROR() {
        return {
            code: 80200,
            message: 'Please try again.'
        };
    }

    static get INVALID_VIDEO_TYPE() {
        return {
            code: 80006,
            message: 'The specified video type is not valid.'
        };
    }

    static get EMPTY_FEED() {
        return {
            code: 80201,
            message: LanguageManager.get('error_cannot_load_feed')
        };
    }

    static get GEO_BLOCK() {
        return {
            code: 80202,
            message: LanguageManager.get('error_570106_invalid_country')
        };
    }

    static get UNEXPECTED_ESB_RESPONSE() {
        return {
            code: 80203,
            message: LanguageManager.get('error_cannot_load_feed')
        };
    }
}



// WEBPACK FOOTER //
// ./src/modules/feed/errors.js